import React, {Component} from "react";
import { observer } from "mobx-react";
import {Link} from "react-router-dom";
import {fn_currMenuGroupList} from "../../../../../function/FnBodyMenu";

@observer
class OrderMenuLeftItemView extends Component {

    render() {
        const { rootStore, obj } = this.props;
        const groupCode = rootStore.menuStore.getMenuGroupCode;

        let leftMenuTotal = 0
        let leftMenuSoldOutCount = 0
        if( Array.isArray(obj.prods) && obj.prods.length > 0 ) {
            obj.prods.map(leftMenu => {
                leftMenuTotal++;
                if(leftMenu.soldOut === "Y")
                    leftMenuSoldOutCount++;
            })
        }
        return (
            <li className={groupCode===obj.tuClsCd?'on' : ''}
                    onClick={ (event) => fn_currMenuGroupList(rootStore, obj.tuClsCd)} >
                <Link to="#" ><strong>{obj.tuClsNm}</strong>({leftMenuTotal-leftMenuSoldOutCount}/{leftMenuTotal})</Link>
            </li>
        );
    }
}

export default OrderMenuLeftItemView;